class Annotation {
  id: string;

  ticket_id: number;

  x: number;

  y: number;

  width: number;

  height: number;

  text: string;

  constructor(data: object = {}) {
    Object.assign(this, data);
  }
}

export default Annotation;
